/**
 * Componente Card
 * Wrapper para o Card do Ant Design
 */

import React from "react";
import { Card as AntCard } from "antd";

const Card = ({
  children,
  title,
  subtitle,
  header,
  footer,
  variant = "default",
  hover = false,
  className,
  onClick,
  ...props
}) => {
  // Estilos padrão minimalistas - estilo da imagem
  // Usa classes Tailwind que respondem ao tema através das variáveis CSS
  const defaultStyles = {
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04)",
    // backgroundColor será definido via className usando bg-card
    border: "none",
  };

  const cardProps = {
    className: `bg-card text-card-foreground ${className || ""}`,
    hoverable: hover || !!onClick,
    onClick,
    style: {
      ...defaultStyles,
      ...props.style,
    },
    ...props,
  };

  // Se tiver header customizado, renderiza no title
  const cardTitle =
    header ||
    (title && (
      <>
        {title}
        {subtitle && (
          <div
            className="text-muted-foreground"
            style={{
              fontSize: "0.875rem",
              fontWeight: "normal",
              marginTop: "4px",
            }}
          >
            {subtitle}
          </div>
        )}
      </>
    ));

  return (
    <AntCard title={cardTitle} extra={footer} {...cardProps}>
      {children}
    </AntCard>
  );
};

export default Card;
